import { composeEndpoint } from 'mocks/utils/composeEndpoint';
import { rest } from 'msw';

export const docusignHandlers = [
  rest.post(
    composeEndpoint(`/docusign/:documentId/create-envelope`),
    (req, res, ctx) => res(ctx.json({ docuSignUrl: 'https://test.com' })),
  ),
];
